<button tabindex="-1" class="close-button" [mat-dialog-close]="undefined" mat-icon-button>
  <mat-icon class="notranslate">close</mat-icon>
</button>

<h1>Junior loan information</h1>

<mat-dialog-content>
  <ul class="details-list" *ngIf="model.lenderInformation as info">
    <li class="details-list-item" *ngIf="info.amountJunior">
      <label>Junior loan amount </label>{{ info.amountJunior | terraCurrency }} {{ model.currency.iso }}
    </li>
    <li class="lo_sensitive details-list-item" *ngIf="info.lenderName">
      <label>Lender name</label> {{ model.lenderInformation.lenderName }}
    </li>
    <li class="details-list-item" *ngIf="info.closingDateJunior"><label>Closing date</label>
      {{ model.lenderInformation.closingDateJunior | date}}
    </li>
    <li class="details-list-item" *ngIf="info.maturityDateJunior"><label>Maturity date</label>
      {{ model.lenderInformation.maturityDateJunior | date}}
    </li>
    <li class="details-list-item" *ngIf="info.loanTypeJunior"><label>Loan type</label>
      {{ model.lenderInformation.loanTypeJunior | enumString : LoanType }}
    </li>

    <!-- LoanToValue legacy -->
    <li class="details-list-item"
        *ngIf="info.loanToValueJunior !== null && info.loanToValueJunior !== undefined else autoCalcLoanToValue">
      <label>Loan to value</label>{{ model.lenderInformation.loanToValueJunior }}%
    </li>

    <ng-template #autoCalcLoanToValue>
      <li class="details-list-item"
          *ngIf="model.estimatedMarketValue !== null && model.estimatedMarketValue !== undefined">
        <label>Loan to value</label>
        {{ (info.amountJunior / model.estimatedMarketValue) * 100 | terraNumber }}%
      </li>
    </ng-template>

    <li class="details-list-item" *ngIf="info.interestRateJunior !== null && info.interestRateJunior !== undefined">
      <label>Interest rate</label>
      <span>
        <span
          *ngIf="info.interestTypeJunior !== null && info.interestTypeJunior !== undefined && info.interestTypeJunior !== 0">
          {{model.lenderInformation.interestTypeJunior | enumString: InterestType}}
        </span>
        <span> {{model.lenderInformation.interestTypeJunior === InterestType.Fixed ? 'at' : '+'}}</span>
        {{ model.lenderInformation.interestRateJunior }}%
      </span>
    </li>

    <li class="details-list-item" *ngIf="model.totalCost !== null && model.totalCost !== undefined">
      <label> Loan to Cost</label>
      {{ (info.amountJunior / model.totalCost) * 100 | terraNumber }}%
    </li>
  </ul>

  <!-- Additional terms -->
  <div *ngIf="model.lenderInformation.additionalTermsJunior">
    <h2 class="additional-terms">Additional terms</h2>
    <mat-dialog-content>
      <div class="lo_sensitive html-content" [innerHTML]="model.lenderInformation.additionalTermsJunior | safeHtml">
      </div>
    </mat-dialog-content>
  </div>
</mat-dialog-content>
